import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ActivityCategoryForm from '../../../components/forms/ActivityCategoryForm';
import { useCreateActivityCategory } from '../../../hooks/useActivityCategoryApi';
import { useNavigate } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { ActivityCategoryDTO } from '../../../services/apiClient';

const ActivityCategoryCreate: React.FC = () => {
  const navigate = useNavigate();
  const createMutation = useCreateActivityCategory();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Activity Categories', href: '/admin/activitycategories' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: ActivityCategoryDTO) => {
    try {
      await createMutation.mutateAsync(data);
      navigate('/admin/activitycategories');
    } catch (error) {
      console.error('Error creating Activity Category:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/activitycategories"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.ActivityCategory.Edit"
    >
      <ActivityCategoryForm
        initialValues={{} as ActivityCategoryDTO}
        onSubmit={handleSubmit}
        onCancel={() => navigate('/admin/activitycategories')}
      />
    </AdminLayout>
  );
};

export default ActivityCategoryCreate;
